import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AuthCheck from '../hooks/AuthCheck';
import { Routes } from "../routes";

const Welcome = () => {
    AuthCheck();
    const user = localStorage.getItem('user');
    let auth_user = '';
    if (user) {
        auth_user = JSON.parse(user);
    }

    useEffect(() => {
        document.body.classList.add('welcome-page');
        return () => {
            document.body.classList.remove('welcome-page');
        };
    }, []);

    // Function to handle module selection and store in localStorage
    const handleModuleSelect = (module) => {
        localStorage.setItem('selectedModule', module);
    };

    return (
        <div className="welcome-container d-flex flex-column align-items-center px-3">
            <h2 className="welcome-title">Welcome, {auth_user && auth_user.name}</h2>
            <p className="welcome-subtitle">Easily pin your most frequently used features here for quick access</p>

            {/* <div className="section w-100">
                <h6 className="section-title">My favourites</h6>
                <div className="grid-2">
                    <Link
                        to={{ pathname: "/dashboardoverview", state: { section: "Admin" } }}
                        className="app-card"
                        onClick={() => handleModuleSelect('Admin')}
                    >
                        <div className="icon user-icon"></div>
                        <div className="app-info">
                            <strong>Admin</strong>
                            <p>Manage users, permissions, and system settings</p>
                        </div>
                    </Link>
                    <Link
                        to={Routes.DashboardOverview.path}
                        className="app-card"
                        onClick={() => handleModuleSelect('Inventory')}
                    >
                        <div className="icon inventory-icon"></div>
                        <div className="app-info">
                            <strong>ERP Inventory</strong>
                            <p>Manage stock levels and streamline warehouse operations</p>
                        </div>
                    </Link>
                </div>
            </div> */}

            <div className="section w-100">
                <h6 className="section-title">My Apps</h6>
                <div className="grid-2">
                    <Link
                        to={{ pathname: "/dashboardoverview", state: { section: "Admin" } }}
                        className="app-card"
                        onClick={() => handleModuleSelect('Admin')}
                    >
                        <div className="icon user-icon"></div>
                        <div className="app-info">
                            <strong>Admin</strong>
                            <p>Manage users, permissions, and system settings</p>
                        </div>
                    </Link>
                    <Link
                        to={Routes.DashboardOverview.path}
                        className="app-card"
                        onClick={() => handleModuleSelect('Inventory')}
                    >
                        <div className="icon inventory-icon"></div>
                        <div className="app-info">
                            <strong>ERP Inventory</strong>
                            <p>Manage users, permissions, and system settings</p>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Welcome;